/**
 * Certificate Search Application Entry Point
 * Vanilla TypeScript replacement for Vue.js implementation
 */

import { CertificateSearch } from './CertificateSearch';

/**
 * Show error state and hide loading state
 */
function showError(errorMessage: string): void {
    const loadingEl = document.querySelector('.certificate-search__loading');
    const errorEl = document.querySelector('.certificate-search__error');
    const errorDetailsEl = document.querySelector('.certificate-search__error-details');

    if (loadingEl) {
        (loadingEl as HTMLElement).style.display = 'none';
    }

    if (errorEl) {
        (errorEl as HTMLElement).style.display = 'block';
    }

    if (errorDetailsEl) {
        errorDetailsEl.textContent = errorMessage;
    }
}

/**
 * Initialize the Certificate Search application
 */
function initializeCertificateSearch(): void {
    try {
        // Create and initialize the certificate search application
        new CertificateSearch();
    } catch (error) {
        // Certificate Search initialization failed - error handling could be added here
        showError(`Initialization failed: ${error instanceof Error ? error.message : 'Unknown error'}`);
    }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeCertificateSearch);
} else {
    // DOM is already ready
    initializeCertificateSearch();
}

// Export for global access if needed
(window as any).CertificateSearch = CertificateSearch;
